<div class="calendar-popup" (keyup.space)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (click)="$event.stopPropagation()" [class.disabled]="disabled" [style.top]="position">
    <!-- Navigation Buttons -->
    @if (!showMonths && !showCalendar) {
      <div class="calendar-header">
        <div class="nav-button">
          <button type="button" class="custom-calendar-prev-btn" (click)="previousRange()" [disabled]="commonObj.headPrevDisabled">
            <mat-icon fontSet="material-symbols-outlined"> chevron_left </mat-icon>
          </button>
        </div>
        <div class="f-col custom-calendar-value">
          <button type="button" class="button-as-div year-range year-cell" (click)="onYearRangeClick()"> {{ currentRangeStart }} – {{ (currentRangeStart + 23) >= allowedYearFlag ? allowedYearFlag : currentRangeStart + 23 }} </button>
          @if (isHijri) {
            <button type="button" class="button-as-div year-range year-cell" (click)="onYearRangeClick()"> {{ getHijriYear(currentRangeStart + '-01-01') }} – {{ getHijriYear(currentRangeStart + '-01-01') }} </button>
          }
        </div>
        <div class="nav-button">
          <button type="button" class="custom-calendar-next-btn" (click)="nextRange()" [disabled]="isNextRange || commonObj.headNextDisabled">
            <mat-icon fontSet="material-symbols-outlined"> chevron_right </mat-icon>
          </button>
        </div>
      </div>
    }

    <!-- Year Grid -->
    @if (!showMonths && !showCalendar) {
      <div class="year-grid">
        @for (year of years; track year.gregorian) {
          <button type="button" class="button-as-div year-cell" [class.disabled]="year.disabled" [class.selected]="selectedYear === year.gregorian" (click)="!year.disabled && selectYear(year.gregorian)">
            @if (isHijri) {
              <div class="hijri-month"> {{ year.hijri }} </div>
            }
            <div [class.disabled]="year.disabled"> {{ year.gregorian }} </div>
          </button>
        }
      </div>
    }

    <!-- Month Grid -->
    @if (showMonths && !showCalendar) {
      <div class="year-grid">
        <div class="calendar-header">
          <div class="nav-button">
            <button type="button" class="custom-calendar-prev-btn" (click)="previousMonthRange()" [disabled]="maxDate.year + 1 === selectedYear || commonObj.headPrevDisabled">
              <mat-icon fontSet="material-symbols-outlined"> chevron_left </mat-icon>
            </button>
          </div>
          <div class="f-col custom-calendar-value">
            <button type="button" class="button-as-div" (click)="openLastMonthOfYear()"> {{ selectedYear }} </button>
            @if (isHijri) {
              <div> {{ selectedHijriYear }} </div>
            }
          </div>
          <div class="nav-button">
            <button type="button" class="custom-calendar-next-btn" (click)="nextMonthRange()" [disabled]="commonObj.headNextDisabled">
              <mat-icon fontSet="material-symbols-outlined"> chevron_right </mat-icon>
            </button>
          </div>
        </div>

        @for (month of months; track month.gregorian) {
          <button type="button" class="button-as-div year-cell" [class.disabled]="month.disabled" [class.selected]="selectedMonth === month.gregorian" (click)="!month.disabled && selectMonth(month.gregorian)">
            @if (isHijri) {
              <div class="hijri-month"> {{ month.hijri }}. </div>
            }
            <div> {{ month.gregorian }} </div>
          </button>
        }
      </div>
    }

    <!-- Calendar Grid -->
    @if (showCalendar) {
      <div class="calendar-grid">
        <div class="calendar-header">
          <div class="nav-button">
            <button type="button" class="custom-calendar-prev-btn" (click)="previousDayRange()" [disabled]="maxDate.year + 1 === selectedYear || commonObj.headPrevDisabled">
              <mat-icon fontSet="material-symbols-outlined"> chevron_left </mat-icon>
            </button>
          </div>
          <button type="button" class="button-as-div f-col custom-calendar-value" (click)="backToYearRange()">
            <b> {{ selectedMonth | uppercase }} {{ selectedYear }} </b>
            @if (isHijri) {
              <div> {{ selectedHijriMonth }} {{ selectedHijriYear }} </div>
            }
          </button>
          <div class="nav-button">
            <button type="button" class="custom-calendar-next-btn" (click)="nextDayRange()" [disabled]="commonObj.headNextDisabled">
              <mat-icon fontSet="material-symbols-outlined"> chevron_right </mat-icon>
            </button>
          </div>
        </div>
        <div class="day-grid">
          <div class="day-cell header">{{ dictionaryContent?.['sun'] || 'Sun' }}</div>
          <div class="day-cell header">{{ dictionaryContent?.['mon'] || 'Mon' }}</div>
          <div class="day-cell header">{{ dictionaryContent?.['tue'] || 'Tue' }}</div>
          <div class="day-cell header">{{ dictionaryContent?.['wed'] || 'Wed' }}</div>
          <div class="day-cell header">{{ dictionaryContent?.['thu'] || 'Thu' }}</div>
          <div class="day-cell header">{{ dictionaryContent?.['fri'] || 'Fri' }}</div>
          <div class="day-cell header">{{ dictionaryContent?.['sat'] || 'Sat' }}</div>
          @for (day of calendarDays; track $index) {
            <button type="button" class="button-as-div day-cell" [class.selected]="day.day === selectedDay" [class.disabled]="day.disabled" (click)="day.day !== null && selectDay(day.day)">
              @if (isHijri && day.hijri) {
                <div class="hijri-date"> {{ day.hijri }} </div>
              }
              @if (day.day !== null) {
                <div> {{ day.day }} </div>
              }
            </button>
          }
        </div>
      </div>
    }
    <div class="f-row buttons calender-selction-action">
      <div class="show__toggle">
        <div class="hijri-dates">
          <div class="hijri">
            <label class="switch" [ngClass]="{'switchtoggle':isHijri}">
              <input class="toggleBox" id="hijiriCheckbox" tabindex="-1" [aria-label]="content?.['b2b.booking.hijricalendar'] || 'Hijri Calendar'"
                (change)="toggleCalendar()" type="checkbox" [checked]="isHijri" [disabled]="false">
              <div></div>
            </label>
            <span id="toggleHijriText" aria-hidden="true">{{content?.['b2b.booking.hijricalendar'] || 'Hijri Calendar'}}</span>
          </div>
        </div>

      </div>
      <div class="buttons_input">
        <button mat-button type="button" [class.disabled]="disabled" (click)="confirmSelection()" [disabled]="disabled"
          class="button--primary-small mat-button btn">{{content?.['b2b.book.global.confirm'] || 'Confirm'}}</button>
      </div>
    </div>
</div>
